import { styled } from 'stitches.config'
import { PorkteinRoot } from '../Porktein/Porktein.styles'
import { Text } from 'components/Text'

export const BisonRoot = styled(PorkteinRoot, {
  background: '$tertiary-200',

  '@bp3': {
    paddingTop: '$15'
  }
})

export const Feat1 = styled(Text, {
  position: 'absolute',
  left: 0,
  right: 0,
  margin: 'auto',
  zIndex: 1,
  top: '210px',

  '@bp3': {
    left: 0,
    right: 0,
    top: '300px',
    transform: 'translateX(-400px)',
    width: '240px',

  },
})

export const Cup = styled('div', {
  position: 'absolute',

  left: '250px',
  right: 0,
  margin: 'auto',
  zIndex: 1,
  textAlign: 'center',
  top: '570px',
  rotate: '-140deg',
  width: '90px',

  '@mobile': {
    left: '300px',
  },

  '@bp3': {
    rotate: '180deg',
    transform: 'scaleX(-1)',
    right: '570px',
    top: '210px',
    width: '99px',
    left: 0,
  },
})

export const Snake = styled('div', {
  position: 'absolute',

  left: '250px',
  right: 0,
  margin: 'auto',
  zIndex: 1,
  textAlign: 'center',
  top: '570px',
  rotate: '-140deg',


  '@mobile': {
    left: '300px',
  },

  '@bp3': {
    transform: 'scaleX(-1)',
    rotate: '0deg',
    right: '550px',
    top: '570px',
    left: 0,
  },
})

export const Shoelace = styled('div', {
  position: 'absolute',

  left: 0,
  right: 0,
  top: '200px',
  transform: 'translateY(-110px)',
  margin: 'auto',
  zIndex: 1,
  textAlign: 'center',
  rotate: '90deg',
  width: '190px',

  '@bp3': {
    right: 0,
    rotate: '0deg',
    top: '190px',
    display: 'block',
    transform: 'scaleX(-1)',
    width: '200px',
    left: '620px',
  },
})

export const Feat2 = styled(Text, {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '660px',
  margin: 'auto',

  '@bp3': {
    left: 0,
    right: 0,
    top: '530px',
    transform: 'translateX(-400px)',
  },
})

export const Feat3 = styled(Text, {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '700px',
  margin: 'auto',

  '@bp3': {
    left: 0,
    right: 0,
    top: '370px',
    transform: 'translateX(420px)',
  },
})

export const BadgeWrapper = styled('div', {
  position: 'absolute',
  zIndex: 2,
  bottom: 'unset',
  top: '450px',
  left: 0,
  right: '220px',
  margin: 'auto',
  textAlign: 'center',
  width: '98px',
  height: '98px',
  display: 'none',

  '@mobile': {
    display: 'block',
  },

  '@bp3': {
    height: '163px',
    width: '163px',
    bottom: '170px',
    left: '430px',
    top: 'unset',
    right: 0,
  },
})